/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages
        var $fixedheight = $(".menu-fixed").height();
          AOS.init({
            duration: 1500,
            disable: 'mobile'
          });
        // $(".wrapper").css("padding-top", $fixedheight + "px");
        // $(window).on("resize", function () {
        //   var $fixedheight = $(".menu-fixed").height();
        //   $(".wrapper").css("padding-top", $fixedheight + "px");
        // });
        if ($(".video-popup-checker").length) {
          $("#myModal").css("display", "flex");
          $("body").css("overflow", "hidden");
        }
        var num = 125; //number of pixels before modifying styles
        $(window).bind("scroll", function () {
          if ($(window).scrollTop() > num) {
            $("body").addClass("body-scrolled");
          } else {
            $("body").removeClass("body-scrolled");
          }
        });

         $(".menu-utility .menu-open").click(function() {
          $(".menu-off-canvas .menu-secondary .menu-item").toggleClass("slider-list");
          $(".menu-off-canvas .menu-secondary .menu-item").removeClass("hide-list");
         });
        
        $(".dropdown-menu").removeClass("slider-dropdown");
        $(".menu-side .bar-container").click(function () {
          $(".dropdown-menu").addClass("slider-dropdown");
          $(".dropdown-menu").removeClass("hide-dropdown");
          $("#menu-secondary .menu-item").addClass("slider-list");
          $("#menu-secondary .menu-item").removeClass("hide-list");
          $(".hr_footer").addClass("show-footer");
          $(".mid-img").removeClass("fade-in");
          $(".bar-holder").removeClass("fade-in");
          $(".topbar").removeClass("fade-in");
          $(".mid-img").addClass("fade-out");
          $(".bar-holder").addClass("fade-out");
          $(".topbar").addClass("fade-out");
           $(".block-one").addClass("fade-in");
          $(".block-two").addClass("fade-in");
          $("body").css("overflow","hidden");
        });

        $(".dropdown-menu .close").click(function() {
          $(".dropdown-menu").addClass("hide-dropdown");
          $("#menu-secondary .menu-item").addClass("hide-list");
          $("#menu-secondary .menu-item").removeClass("slider-list");
          $(".hr_footer").removeClass("show-footer");
           $(".mid-img").removeClass("fade-out");
          $(".bar-holder").removeClass("fade-out");
          $(".topbar").removeClass("fade-out");
          $(".mid-img").addClass("fade-in");
          $(".bar-holder").addClass("fade-in");
          $(".topbar").addClass("fade-in");
           $(".block-one").removeClass("fade-in");
          $(".block-two").removeClass("fade-in");
          $("body").css("overflow","auto");
         });
        
        $(".sub-arrow").click(function () {
          $(this).find("i").toggleClass("turn-arrow");
          $(this).siblings(".sub-pages").toggleClass("tap");
        });

        var modal = document.getElementById("myModal");

        // Get the button that opens the modal
        var btn = document.getElementById("myBtn");

        // Get the <span> element that closes the modal
        var span = document.getElementsByClassName("close")[0];

        // When the user clicks on the button, open the modal

        $("#popup_module").click(function () {
          $("#myModal").css("display", "flex");
          $("body").css("overflow", "hidden");
        });

        $(".close").click(function () {
          $("#myModal").css("display", "none");
          $("body").css("overflow", "auto");
          $("#myModal").remove();
        });

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function (event) {
          if (event.target === modal) {
            modal.style.display = "none";
            $("body").css("overflow", "auto");
          }
        };

        // SLICK HEROES
        $(".js-slick-heroes").slick({
          dots: true,
          infinite: true,
          arrows: false,
          speed: 500,
          autoplay: true,
          autoplaySpeed: 5000,
          fade: true,
          draggable: false,
          slidesToShow: 1,
          adaptiveHeight: true,
          pauseOnHover: true,
          customPaging: function (slider, i) {
            // var title = $(slider.$slides[i]).data('title');
            return "";
          },
          responsive: [
            {
              breakpoint: 500,
              settings: {
                dots: true,
                arrows: false,
              },
            },
          ],
        });

        $(".js-slick-notifications").slick({
          dots: false,
          infinite: true,
          arrows: false,
          // prevArrow: $('.js-hero-prev'),
          // nextArrow: $('.js-hero-next'),
          speed: 500,
          autoplay: true,
          autoplaySpeed: 5000,
          fade: true,
          draggable: false,
          slidesToShow: 1,
          adaptiveHeight: true,
          pauseOnHover: true,
          customPaging: function (slider, i) {
            // var title = $(slider.$slides[i]).data('title');
            return "";
          },
        });

        $(".js-loadmore-posts").click(function () {
          var button = $(this),
            data = {
              action: "loadmore",
              query: loadmore_posts_params.posts, // that's how we get params from wp_localize_script() function
              page: loadmore_posts_params.current_page,
            };

          $.ajax({
            url: loadmore_posts_params.ajaxurl, // AJAX handler
            data: data,
            type: "POST",
            beforeSend: function (xhr) {
              button.html('<span class="button primary">Loading...</span>'); // change the button text, you can also add a preloader image
            },
            success: function (data) {
              if (data) {
                button
                  .html('<span class="button primary">More posts</span>')
                  .before(data); // insert new posts
                loadmore_posts_params.current_page++;

                if (
                  loadmore_posts_params.current_page ===
                  loadmore_posts_params.max_page
                ) {
                  button.remove(); // if last page, remove the button
                }

                // you can also fire the "post-load" event here if you use a plugin that requires it
                // $( document.body ).trigger( 'post-load' );
              } else {
                button.remove(); // if no data, remove the button as well
              }
            },
          });
        });

        $(".js-select2").select2({
          minimumResultsForSearch: Infinity,
        });

        $(".js-select2-search").select2();

        $(".js-selector-with-url").change(function () {
          location.href = $(this).val();
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        $(".js-jac-account-form").submit(function (e) {
          e.preventDefault();
          var $this = $(this);
          $this.find("button[type=submit]").prop("disabled", true);
          showLoader();
          $.ajax({
            type: $this.attr("method"),
            dataType: "json",
            url: templateJS.ajaxURL,
            data: {
              action: "jac_account_" + $this.data("action"),
              data: $this.serialize(),
            },
            success: function (r) {
              hideLoader();
              $this.find("button[type=submit]").prop("disabled", false);
              if (r.success) {
                if (r.data && r.data.message) {
                  // if don't need success message, remove class at markup
                  $this.find(".js-success-message").text(r.data.message);
                }

                if (r.data && r.data.hidden) {
                  $this.find(".js-fields").hide("slow");
                }
                if (r.data && r.data.disabled) {
                  $this.find("input,button,textarea").prop("disabled", true);
                }

                if (r.data && r.data.url) {
                  if (r.data.url === "#") {
                    location.reload();
                  } else {
                    setTimeout(function () {
                      location.href = r.data.url;
                    }, 3000);
                  }
                }
              } else {
                if (r.data && r.data.message) {
                  $this.find(".js-error-message").text(r.data.message);
                } else {
                  alert("Something wrong, seriously.");
                }
              }
            },
          });
        });

        var $body = $("body");
        var $fixedheight = $(".menu-fixed").height();
        // $(".wrapper").css("padding-top", $fixedheight + "px");
        //Toggle Filter Options
        $(".js-filter-expand").click(function () {
          $(".js-filter-expander").toggleClass("expanded");
        });

        //Toggle menu
        $(".js-menu-open").click(function () {
          $("body").toggleClass("menu-off-canvas-active");
          $body.removeClass("fb-messenger-active");
          $body.removeClass("popup-active-feedback");
        });

        $(".js-menu-open-left").click(function () {
          $body.toggleClass("menu-off-canvas-active");
          $body.toggleClass("left");
          $body.removeClass("fb-messenger-active");
          $body.removeClass("popup-active-feedback");
        });

        //Toggle Feedback
        $(".js-popup-feedback").click(function () {
          $body.toggleClass("popup-active-feedback");
          $body.removeClass("fb-messenger-active");
        });

        //Toggle FB Messenger
        $(".js-fb-messenger").click(function () {
          $body.toggleClass("fb-messenger-active");
          $body.removeClass("menu-off-canvas-active");
        });

        //Toggle Search
        $(".js-popup-search").click(function (e) {
          e.preventDefault();
          $(".popup-wrap-search input").focus();
          $body.toggleClass("popup-active-search");
        });

        $(document).keyup(function (e) {
          if (e.keyCode === 27) {
            // escape key maps to keycode `27`
            $body.removeClass(
              "body-is-scrolled menu-off-canvas-active popup-active-search fb-messenger-active popup-active-feedback left"
            );
          }
        });

        //Toggle accordion links
        $(document).on("click", ".js-accordion-title", function (e) {
          e.preventDefault();
          $(this)
            .closest(".js-accordion")
            .toggleClass("expanded")
            .siblings()
            .removeClass("expanded");
        });

        $(".js-popup-feedback-form").submit(function (e) {
          e.preventDefault();

          var $this = $(this);
          var $message = $this.find(".js-message");

          $.ajax({
            type: "get",
            url: templateJS.ajaxURL,
            dataType: "json",
            data: {
              action: "popup_feedback_submit",
              data: $this.serialize(),
            },
            success: function (r) {
              if (r.success) {
                $this.find("input,textarea,button").prop("disabled", true);
                $message.text(
                  "Successful. This popup will automatically close in 5 seconds."
                );
                setTimeout(function () {
                  $body.toggleClass("popup-active-feedback");
                  $this.find("input,textarea,button").prop("disabled", false);
                  $this.find("input,textarea").val("");
                  $message.text(
                    "Please fill out the form below to leave feedback."
                  );
                }, 5000);
              } else {
                $message.hide("slow", function () {
                  $message.text(r.data.message);
                  $message.show("slow");
                });
              }
            },
          });
        });
      },
    },
    // Home page
    home: {
      init: function () {
         $(".js-slider-for").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          // prevArrow:'<span class="slick-prev"><i class="far fa-long-arrow-left"></i></span>',
          // nextArrow:'<span class="slick-next"><i class="far fa-long-arrow-right"></i></span>',
          fade: true,
          asNavFor: ".js-slider-nav",
          adaptiveHeight: true,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                dots: false,
                customPaging: function(slider, i) {
                  // var title = $(slider.$slides[i]).data('title');
                  return "";
                }
              }
            }
          ]
        });

        $(".js-slider-nav").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: ".js-slider-for",
          arrows: true,
          prevArrow:'<span class="slick-prev"><i class="far fa-long-arrow-left"></i></span>',
          nextArrow:'<span class="slick-next"><i class="far fa-long-arrow-right"></i></span>',
          // centerMode: true,
          draggable: true,
          focusOnSelect: true,
          adaptiveHeight: true,
          infinite: true
        });
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    barbados: {
      init: function () {
        $('.modal-toggle').on('click', function(e) {
          e.preventDefault();
          var className = ".modal-info." + $(this).attr('id');
          $(className).toggleClass('is-visible');
          // $(className).toggleClass('is-visible');
          $("body").toggleClass('overflow-hidden');
        });
        // JavaScript to be fired on the about us page
      },
    },
    lookbook: {
      init: function () {
         $(".js-slick-testimonials").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          autoplay: true,
          autoplaySpeed: 5000,
          easing: "swing",
          // dots: false,
          arrows: true,
          prevArrow:'<span class="slick-prev"><i class="far fa-long-arrow-left"></i></span>',
          nextArrow:'<span class="slick-next"><i class="far fa-long-arrow-right"></i></span>',
          centerMode: false,
          draggable: true,
          focusOnSelect: true,
          adaptiveHeight: true,
          pauseOnHover: true,
          infinite: true,
          dots: false,
          mobileFirst: true
         });
        
        $(".cat-lookbook:first-child").addClass("active");
         $(".section-gallery:first-child").addClass("show-gallery");
        $('.cat-lookbook').on('click', function(e) {
          e.preventDefault();
          $(".cat-lookbook").removeClass("active");
          $(this).addClass("active");
          var className = ".section-gallery." + $(this).attr('id');
          $(".section-gallery").removeClass('show-gallery');
          $(className).addClass('show-gallery');
          $('html,body').delay(500).animate({
              scrollTop: $(".gallery-div").offset().top},
              'slow');
        });
        // JavaScript to be fired on the about us page
      },
    },
    the_villas: {
      init: function() {
        $(".flex-villas .full-content").click(function(e) {
          $(".flex-villas .flex-one").removeClass("expand");
          $(".flex-villas").addClass("expand-villas");
          $(".holder_box .fa-long-arrow-left").addClass("show-icon");
          $(".holder_box .fa-long-arrow-right").addClass("show-right-icon");
          $(this).addClass("expand");
          $(".villa-section").addClass("hide-background");
          $(".villas-page #content-villa").addClass("hide-opacity");
        });
        $(".holder_box .fa-long-arrow-left").click(function(e) {
          $(".flex-villas .flex-one").removeClass("expand");
          $(".flex-villas").addClass("expand-villas");
          $(".holder_box .fa-long-arrow-left").addClass("show-icon");
          $(".holder_box .fa-long-arrow-right").addClass("show-right-icon");
          $(".flex-villas .flex-one:first-child").addClass("expand");
          $(".villa-section").addClass("hide-background");
          $(".villas-page #content-villa").addClass("hide-opacity");
        });
        $(".holder_box .fa-long-arrow-right").click(function(e) {
          $(".flex-villas .flex-one").removeClass("expand");
          $(".flex-villas").removeClass("expand-villas");
          $(".holder_box .fa-long-arrow-left").removeClass("show-icon");
          $(".holder_box .fa-long-arrow-right").removeClass("show-right-icon");
          $(".flex-villas .flex-one:first-child").removeClass("expand");
          $(".villa-section").removeClass("hide-background");
          $(".villas-page #content-villa").removeClass("hide-opacity");
        });
        // JavaScript to be fired on the about us page
      }
    },
    contact: {
      init: function () {
        // JavaScript to be fired on the contact page
        var gmap_id = $(".gmapcontact"),
          zoom = gmap_id.data("zoom") || 18,
          address = gmap_id.data("address") || "NL, Canada",
          url = "https://www.google.com/maps/place/Porters+Place,+Luxury+Villas/@13.1986349,-59.6394226,17z/data=!3m1!4b1!4m12!1m6!3m5!1s0x8c43f1be30295465:0xe9acf6de7a9b8b69!2sPorters+Place,+Luxury+Villas!8m2!3d13.1986349!4d-59.6372339!3m4!1s0x8c43f1be30295465:0xe9acf6de7a9b8b69!8m2!3d13.1986349!4d-59.6372339",
          geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: address }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            var centerLL = results[0].geometry.location;

            var map = new google.maps.Map(gmap_id.get(0), {
              center: centerLL,
              scrollwheel: false,
              zoom: zoom || 18,
            });
            var marker = new google.maps.Marker({
              map: map,
              position: centerLL,
              title: results[0].formatted_address,
              url: url
            });
          } else {
            console.log(
              "Geocode was not successful for the following reason: " + status
            );
            $(".gmapcontact").html(
              '<div class="blurb no-results"><h3>Google Maps is not available due to unavailable location data.</h3></div>'
            );
          }
          google.maps.event.addListener(marker, 'click', function() {
            window.open(this.url, '_blank');
          });
        });


      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function (
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
